import { isWebBrowser } from '../../utils';

export const checkIfHasPointerDevice = () =>
  isWebBrowser() && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
